'use client';

import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { CollapsibleInterlinking } from '@page-builder/Components/InterLinking/CollapsibleInterLinking/CollapsibleInterlinking';

import type {
  ExtendedAggregations,
  MakeModelInterlinkingClientProps,
} from './MakeModelInterlinking.entities';
import { transformToInterlinkingContent } from './Utils/transformToInterlinkingContent';

import styles from './MakeModelInterlinking.module.css';

export const MakeModelInterlinkingClient = ({
  serverAggregations,
  make,
  modelWithMake,
  locale,
  messages,
  makeDisplayName,
  modelDisplayName,
  root,
}: MakeModelInterlinkingClientProps) => {
  const atomAggregations = useAtomValue(aggregationsAtom);
  const aggregations: ExtendedAggregations = atomAggregations['body-type']
    ? {
        ...atomAggregations,
        make: serverAggregations.make,
        model: serverAggregations.model,
        variant: serverAggregations.variant,
        // Ensure we have the variants array from atom aggregations
        variants: atomAggregations.variants,
      }
    : serverAggregations;
  const interlinkingContent = transformToInterlinkingContent(
    aggregations,
    make,
    modelWithMake,
    locale,
    messages,
    makeDisplayName,
    modelDisplayName,
    root,
  );
  return (
    <div className={styles.container}>
      <CollapsibleInterlinking {...interlinkingContent} />
    </div>
  );
};
